export const IndexedDBService = {
  dbName: 'auth-session-db',
  storeName: 'session-store',

  openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1)
      request.onupgradeneeded = () => {
        request.result.createObjectStore(this.storeName)
      }
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
    })
  },

  async saveAgencyAuthToken(token) {
    if (typeof token !== 'string') {
      throw new Error('Agency auth token must be a string')
    }

    const db = await this.openDB()
    const tx = db.transaction(this.storeName, 'readwrite')
    const store = tx.objectStore(this.storeName)

    store.put(token, 'agencyAuthToken')

    await tx.complete
    db.close()
  },

  async loadAgencyAuthToken() {
    const db = await this.openDB()
    const tx = db.transaction(this.storeName, 'readonly')
    const store = tx.objectStore(this.storeName)

    const token = await new Promise(resolve => {
      const request = store.get('agencyAuthToken')
      request.onsuccess = () => resolve(request.result || null)
      request.onerror = () => resolve(null)
    })

    db.close()
    return token
  },

  async clearAgencyAuthToken() {
    const db = await this.openDB()
    const tx = db.transaction(this.storeName, 'readwrite')
    tx.objectStore(this.storeName).delete('agencyAuthToken')
    await tx.complete
    db.close()
  }
}

/**
 *
 * @param {string} token
 * @returns {{ admin_id: number; agency_id?: number; authentication_token: string; exp: number; organization_id?: number }}
 */
export const decodeToken = token => {
  const decodedTokenString = atob(token)
  if (!decodedTokenString) throw new Error('Invalid base64 encoded token string')

  const tokenParts = decodedTokenString.split('.')
  if (tokenParts.length !== 3) throw new Error('Invalid JWT format')

  const payload = JSON.parse(atob(tokenParts[1]))

  return payload
}

/**
 *
 * @param {string} token
 */
export const setTokenInStorage = async token => {
  if (token) {
    sessionStorage.setItem('agencyAuthToken', token)
    await IndexedDBService.saveAgencyAuthToken(token)
  } else {
    sessionStorage.clear()
    await IndexedDBService.clearAgencyAuthToken()
  }
}
